document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    const buttons = document.querySelectorAll('.sca-qv-button');

    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        const customEvent = new Event('scaButtonClicked', { bubbles: true });
        button.dispatchEvent(customEvent);
      });
    });

    document.addEventListener('scaButtonClicked', (event) => {
      
      setTimeout(() =>{
      let alloverlays = document.querySelectorAll('.sca-fancybox-overlay');

      alloverlays.forEach((overlay) => {
        overlay.addEventListener('click', () => {
          const customEventtwo = new Event('overlayclicked', { bubbles: true });
          overlay.dispatchEvent(customEventtwo);
        });
      });
    }, 3000)
    });

    document.addEventListener('overlayclicked', (event) => {
      updateCartFooterSection('cart-drawer');
    });

    function updateCartFooterSection(sectionId) {
    
      fetch(`/cart?section_id=${sectionId}`)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const newDocument = parser.parseFromString(html, 'text/html');
          const updatedSection = newDocument.querySelector('#cart-drawer-outer');
          
          if (updatedSection) {
            document.querySelector('#cart-drawer-outer').innerHTML = updatedSection.innerHTML;

            let cartDrawer = document.querySelector('cart-drawer.drawer');
            if (cartDrawer) {
              let cart_quant = cartDrawer.getAttribute('data-total');
              console.log("cart_quant: ", cart_quant);
              document.querySelector('.cart-count-bubble span').textContent = cart_quant;

              let cart_price = cartDrawer.getAttribute('data-price');
              document.querySelector('.cart-total__price').textContent = cart_price;
            }
          }
        })
        .catch((error) => {
          console.error('Error updating the section:', error);
        });
    }

  }, 3000);
});